/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import UserPreferences from '@ion/core/src/preferences/UserPreferences';
import {Preference} from '@ion/core/src/types/preferences';
import {getTableHeight} from '@ion/dls/src/components/resizable/ResizableBottomSheet';
import {bottomGridHeightSelector} from '../../../../store/selectors/tracking-selectors';

// defining the constants that are used by the TrackingBottomGrid component..
export const TOP_MARGIN     = 116;
export const INITIAL_HEIGHT = getTableHeight() - TOP_MARGIN;

/**
 *
 * React Hook to provide util functions for getting initial height of bottom grid.
 *
 *  ```typescript
 *
 *   import {useGridHeight} from '@/routes/tracking/hooks';
 *
 *   const [initialHeight] = useGridHeight();
 *
 *  ```
 */
export const useGridHeight = (margin = 0): number => {
  const savedGridHeight = useSelector(bottomGridHeightSelector) ||
  UserPreferences.get(Preference.trackingBottomGridHeight);

  const gridHeight = useMemo(() => {
    return savedGridHeight ? savedGridHeight + TOP_MARGIN + margin: null;
  }, [savedGridHeight]);

  return gridHeight;
};
